import CRUDService from '@/services/hrsg/CRUDService';
import useDownload from '@/composables/useDownload';
const { downloadFile } = useDownload();

export class ReviewService extends CRUDService {
  constructor () {
    super('reviews.reviews');
  }

  async completeSetup (id, data) {
    const response = await this.request({
      endpoint: `${this.endpoint}.complete-setup`,
      pathParams: this.getPathvars({ id }),
      data
    });

    return response?.payload?.data ?? [];
  }

  async verifyAssessments (id, data) {
    const response = await this.request({
      endpoint: `${this.endpoint}.verify-assessments`,
      pathParams: this.getPathvars({ id }),
      data
    });

    return response?.payload?.data ?? [];
  }

  async close (id) {
    return await this.request({
      endpoint: `${this.endpoint}.close`,
      pathParams: this.getPathvars({ id })
    });
  }

  async cancel (id) {
    return await this.request({
      endpoint: `${this.endpoint}.cancel`,
      pathParams: this.getPathvars({ id })
    });
  }

  async reopen (id) {
    return await this.request({
      endpoint: `${this.endpoint}.reopen`,
      pathParams: this.getPathvars({ id })
    });
  }

  async duplicate (id) {
    return await this.request({
      endpoint: `${this.endpoint}.duplicate`,
      pathParams: this.getPathvars({ id })
    });
  }

  async summary (id, queryParams = {}) {
    const response = await this.request({
      endpoint: `${this.endpoint}.summary`,
      pathParams: this.getPathvars({ id }),
      queryParams
    });

    return response?.payload?.data ?? [];
  }

  async shareResults (id, data) {
    const response = await this.request({
      endpoint: `${this.endpoint}.share-results`,
      pathParams: this.getPathvars({ id }),
      data
    });

    return response?.payload?.data ?? [];
  }

  async results (id, type, queryParams = {}) {
    const response = await this.request({
      endpoint: `${this.endpoint}.results`,
      pathParams: this.getPathvars({ id, type }),
      queryParams
    });

    return response?.payload?.data ?? [];
  }

  async checkAdmin (id) {
    const response = await this.request({
      endpoint: `${this.endpoint}.check-admin`,
      pathParams: this.getPathvars({ id })
    });

    return response?.payload?.data ?? [];
  }

  async contents (id) {
    const response = await this.request({
      endpoint: `${this.endpoint}.contents`,
      pathParams: this.getPathvars({ id })
    });

    return response?.payload?.data ?? [];
  }

  async competencyDetails (id, contentId) {
    const response = await this.request({
      endpoint: `${this.endpoint}.competency-details`,
      pathParams: { id, contentId }
    });

    return response?.payload?.data ?? [];
  }

  async export (id, type) {
    return await this.request({
      endpoint: `${this.endpoint}.export`,
      pathParams: { id, type }
    });
  }

  async launchNow (id) {
    return await this.request({
      endpoint: `${this.endpoint}.launch-now`,
      pathParams: { id }
    });
  }

  async downloadPDF (id, assessmentId) {
    const response = await this.request({
      endpoint: `${this.endpoint}.download-pdf`,
      pathParams: { id, assessmentId },
      responseType: 'blob',
      passHeaders: true
    });

    downloadFile(response);
  }
}

export default new ReviewService();
